import React, { FC } from 'react';
import styled from 'styled-components';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';
import { svgHoverColor } from 'styled/utils';

type Props = {
  className?: string;
  circleColor?: Color;
  arrowColor?: Color;
};

const LeftArrowInsideCircle: FC<Props> = ({
  className = '',
  circleColor = 'white',
  arrowColor = 'black',
}) => (
  <Svg
    width="33px"
    height="33px"
    viewBox="0 0 66 66"
    className={className}
    fill="transparent"
  >
    <desc>Left Arrow Icon.</desc>
    <circle
      r="33"
      transform="matrix(-1 0 0 1 33 33)"
      fill={Theme.colors[circleColor]}
    />
    <path
      d="M15.536 33.12L29.936 48.24L33.152 44.976L23.312 35.232H50V31.008H23.312L33.152 21.264L29.936 18L15.536 33.12Z"
      fill={Theme.colors[arrowColor]}
    />
  </Svg>
);

export default styled(LeftArrowInsideCircle)`
  ${svgHoverColor('blue-darker')}
`;
